/**
 * index.js.js
 *
 * @Author: jruif
 * @Date: 2017/8/18 下午4:00
 */

// // 引入样式
// exports.style = require('./src/scss/index.scss');

module.exports = require('./src');



// WEBPACK FOOTER //
// ./index.js